module.exports = __webpack_public_path__ + "img/noteWhite.6a542ba7.svg";